const myAccount = {
  label1: 'Access',
  label2: 'My account',
  label3: 'Exit'
}

export default myAccount;
